import { Style, InputType, DynamicUpdateAction, DynamicUpdateCondition } from 'common/questionnaires/types';
import helpText from 'common/questionnaires/helpText';
import moment from 'moment';
import format from 'date-fns/format';

const crsiQuestions = [
  {
    id: 'CRSI.NAME.1',
    name: 'firstName',
    info: helpText.name,
    questionText: 'preQualifyingQuestionnaire.CRSI.NAME.1.questionText',
    style: Style.Card,
    group: 'Name',
    answer: 'CUSTOMER-NAME',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'First Name', required: true }
      ]
    },
    errorMessage: 'Please provide a first name.'
  },
  {
    id: 'CRSI.NAME.2',
    name: 'middleName',
    answer: 'CUSTOMER-NAME',
    questionText: 'preQualifyingQuestionnaire.CRSI.NAME.2.questionText',
    style: Style.Embedded,
    group: 'Name',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Middle Name', required: false }
      ]
    },
  },
  {
    id: 'CRSI.NAME.3',
    name: 'lastName',
    questionText: 'preQualifyingQuestionnaire.CRSI.NAME.3.questionText',
    style: Style.Embedded,
    answer: 'CUSTOMER-NAME',
    group: 'Name',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Last Name', required: true }
      ]
    },
    errorMessage: 'Please provide a last name.'

  },
  {
    id: 'CRSI.NAME.4',
    name: 'title',
    questionText: 'preQualifyingQuestionnaire.CRSI.NAME.4.questionText',
    style: Style.Embedded,
    group: 'Name',
    inputs: {
      type: InputType.Dropdown,
      defaultValue: { value: '0', label: 'Please Select' },
      items: [
        { value: 'Please Select', label: 'Please Select' },
        { value: 'Mr', label: 'Mr' },
        { value: 'Mrs', label: 'Mrs' },
        { value: 'Ms', label: 'Ms' },
        { value: 'Miss', label: 'Miss' },
        { value: 'Other', label: 'Other' }
      ]
    },
  },
  {
    id: 'CRSI.NAME.5',
    name: 'otherTitle',
    questionText: 'preQualifyingQuestionnaire.CRSI.NAME.5.questionText',
    style: Style.Embedded,
    group: 'Name',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Please type title', required: true }
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSI.NAME.4',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'Other',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    errorMessage: 'Please specify a Title.'
  },
  {
    id: 'CRSI.ADDRESS.1',
    name: 'residenceAddressLine1',
    info: helpText.residenceAddress,
    questionText: 'preQualifyingQuestionnaire.W8BEN.ADDRESS.1.questionText',
    style: Style.Card,
    group: 'Permanent Residence Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Street Address', required: true }
      ]
    },
    errorMessage: 'Please provide a street address.'
  },
  {
    id: 'CRSI.ADDRESS.2',
    name: 'residenceCitystateprovince',
    style: Style.Embedded,
    group: 'Permanent Residence Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'City/State/Province/Territory', required: true }
      ]
    },
    errorMessage: 'Please provide a city, state, province, or territory.'
  },
  {
    id: 'CRSI.ADDRESS.3',
    name: 'residenceCountry',
    style: Style.Embedded,
    group: 'Permanent Residence Address',
    inputs: {
      type: InputType.CountryDropdown,
      invalidSelection: 'Please Select Country',
      defaultSelection: 'Please Select Country',
      defaultValue: { value: 'Please Select Country', label: 'Please Select Country' },
    },
    errorMessage: 'Please provide a country.'
  },
  {
    id: 'CRSI.ADDRESS.4',
    name: 'residencePostalcode',
    style: Style.Embedded,
    group: 'Permanent Residence Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Postal Code' }
      ]
    }
  },
  {
    id: 'CRSI.MAILADDRESS.1',
    name: 'mailAddressLine1',
    info: helpText.mailingAddress,
    questionText: 'preQualifyingQuestionnaire.W8BEN.MAILADDRESS.1.questionText',
    style: Style.Card,
    group: 'Mailing Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Street Address', required: false }
      ]
    },
    partialFieldConstraint: ['CRSI.MAILADDRESS.2', 'CRSI.MAILADDRESS.3'],
    errorMessage: 'Please provide a street address.'
  },
  {
    id: 'CRSI.MAILADDRESS.2',
    name: 'mailCityStateProvince',
    style: Style.Embedded,
    group: 'Mailing Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'City/State/Province/Territory', required: false }
      ]
    },
    partialFieldConstraint: ['CRSI.MAILADDRESS.1', 'CRSI.MAILADDRESS.3'],
    errorMessage: 'Please provide a city, state, province, or territory.'
  },
  {
    id: 'CRSI.MAILADDRESS.3',
    name: 'mailCountry',
    style: Style.Embedded,
    group: 'Mailing Address',
    inputs: {
      type: InputType.CountryDropdown,
      defaultValue: { value: 'Please Select Country', label: 'Please Select Country' },
    },
    partialFieldConstraint: ['CRSI.MAILADDRESS.1', 'CRSI.MAILADDRESS.2'],
    errorMessage: 'Please provide a country.'
  },
  {
    id: 'CRSI.MAILADDRESS.4',
    name: 'mailPostalCode',
    style: Style.Embedded,
    group: 'Mailing Address',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Postal Code', required: false }
      ]
    },
  },
  {
    id: 'CRSI.TIN.1',
    name: 'countryOfTaxResidence1',
    style: Style.Card,
    group: 'Tax Identification Number (TIN)',
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.1.questionText',
    inputs:
    {
      type: InputType.CountryDropdown,
      invalidSelection: 'Select a Country of Tax Residence',
      defaultSelection: 'Select a Country of Tax Residence',
      defaultValue: { value: 'Select a Country of Tax Residence', label: 'Select a Country of Tax Residence' },
    },
    errorMessage: 'Please select a country.'
  },
  {
    id: 'CRSI.TIN.2',
    name: 'tin1',
    info: helpText.crs.tin,
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.2.questionText',
    group: 'Tax Identification Number (TIN)',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'TIN', required: false, validation: 'ftin' },
      ]
    },
    errorMessage: 'Please provide a TIN'
  },
  {
    id: 'CRSI.TIN.3',
    name: 'tinreason1',
    style: Style.Embedded,
    group: 'Name',
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.6.questionText',
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select Reason',
      defaultValue: { value: 'Please Select Reason', label: 'Please Select Reason' },
      items: [
        { value: 'Please Select Reason', label: 'Please Select Reason' },
        { value: 'A', label: 'The country where the account holder is liable to pay tax does not issue TINs to its residents' },
        { value: 'B', label: 'The Account Holder is otherwise unable to obtain a TIN or equivalent number' },
        { value: 'C', label: 'No TIN is required.' },

      ]
    },
  },
  {
    id: 'CRSI.TIN.4',
    name: 'reason1',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.7.questionText',
    group: 'Tax Identification Number (TIN)',
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN.3',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'B',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Residence 1 Reason', required: true },
      ]
    },
    errorMessage: 'Please provide a reason why you are unable to obtain a TIN where you have indicated you are otherwise unable to obtain a TIN or equivalent number.'
  },
  {
    id: 'CRSI.TIN.8',
    name: 'showOtherTinFields1',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.3.questionText',
    group: 'Tax Identification Number (TIN)',
    answer: 1,
    isAnswered: true,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    }
  },
  {
    id: 'CRSI.TIN2.1',
    name: 'countryOfTaxResidence2',
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.4.questionText',
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN.8',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs:
    {
      type: InputType.CountryDropdown,
      invalidSelection: 'Select a Country of Tax Residence',
      defaultSelection: 'Select a Country of Tax Residence',
      defaultValue: { value: 'Select a Country of Tax Residence', label: 'Select a Country of Tax Residence' },
    },
    errorMessage: 'Please select a country.'
  },
  {
    id: 'CRSI.TIN2.2',
    name: 'tin2',
    info: helpText.foreignTin,
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.2.questionText',
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'TIN', required: false, validation: 'ftin' },
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN.8',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSI.TIN2.3',
    name: 'tinReason2',
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.6.questionText',
    style: Style.Embedded,
    group: 'Name',
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select Reason',
      defaultValue: { value: 'Please Select Reason', label: 'Please Select Reason' },

      items: [
        { value: 'Please Select Reason', label: 'Please Select Reason' },
        { value: 'A', label: 'The country where the account holder is liable to pay tax does not issue TINs to its residents' },
        { value: 'B', label: 'The Account Holder is otherwise unable to obtain a TIN or equivalent number' },
        { value: 'C', label: 'No TIN is required.' },
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN.8',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSI.TIN.5',
    name: 'reason2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.7.questionText',
    group: 'Tax Identification Number (TIN)',
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN2.3',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'B',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Residence 2 Reason', required: true },
      ]
    },
    errorMessage: 'Please provide a reason why you are unable to obtain a TIN where you have indicated you are otherwise unable to obtain a TIN or equivalent number.'
  },
  {
    id: 'CRSI.TIN.9',
    name: 'showOtherTinFields2',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.3.questionText',
    group: 'Tax Identification Number (TIN)',
    answer: 1,
    isAnswered: true,
    inputs: {
      type: InputType.YesNo,
      buttonTitles: [
        'Yes', 'No'
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN.8',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSI.TIN3.1',
    name: 'countryOfTaxResidence3',
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.5.questionText',
    inputs:
    {
      type: InputType.CountryDropdown,
      invalidSelection: 'Select a Country of Tax Residence',
      defaultSelection: 'Select a Country of Tax Residence',
      defaultValue: { value: 'Select a Country of Tax Residence', label: 'Select a Country of Tax Residence' },
    },
    errorMessage: 'Please select a country.',
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSI.TIN3.2',
    name: 'tin3',
    info: helpText.foreignTin,
    style: Style.Embedded,
    group: 'Tax Identification Number (TIN)',
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.2.questionText',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'TIN', required: false, validation: 'ftin' },
      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSI.TIN3.3',
    name: 'tinReason3',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.6.questionText',
    group: 'Name',
    inputs: {
      type: InputType.Dropdown,
      defaultSelection: 'Please Select Reason',
      defaultValue: { value: '0', label: 'Please Select Reason' },
      items: [
        { value: 'Please Select Reason', label: 'Please Select Reason' },
        { value: 'A', label: 'The country where the account holder is liable to pay tax does not issue TINs to its residents' },
        { value: 'B', label: 'The Account Holder is otherwise unable to obtain a TIN or equivalent number' },
        { value: 'C', label: 'No TIN is required.' },

      ]
    },
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN.9',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 0,
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
  },
  {
    id: 'CRSI.TIN.6',
    name: 'reason3',
    style: Style.Embedded,
    questionText: 'preQualifyingQuestionnaire.CRSI.TIN.7.questionText',
    group: 'Tax Identification Number (TIN)',
    dynamicUpdate: {
      inputQuestionId: 'CRSI.TIN3.3',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'B',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Residence 3 Reason', required: true },
      ]
    },
    errorMessage: 'Please provide a reason why you are unable to obtain a TIN where you have indicated you are otherwise unable to obtain a TIN or equivalent number.'
  },
  {
    id: 'CRSI.DOB.1',
    name: 'dob',
    style: Style.Card,
    questionText: 'preQualifyingQuestionnaire.CRSI.DOB.1.questionText',
    info: helpText.dateOfBirth,
    group: 'Date and Place of Birth',
    inputs: {
      type: InputType.DateDropdown,
      maxDate: format(moment().subtract(1, 'days').toDate(), 'dd-MM-yyyy'),
      dateFormat: 'dd-MM-yyyy',
      fields: [
        { placeholder: 'Enter Date (DD-MM-YYYY)', required: true }
      ]
    },
    errorMessage: 'Please provide a Date of Birth.'
  },
  {
    id: 'CRSI.DOB.2',
    name: 'countryOfBirth',
    questionText: 'preQualifyingQuestionnaire.CRSI.DOB.2.questionText',
    style: Style.Embedded,
    group: 'Date and Place of Birth',
    inputs: {
      type: InputType.CountryDropdown,
      invalidSelection: 'Please Select Country',
      defaultSelection: 'Please Select Country'
    },
    errorMessage: 'Please provide a country of birth.'
  },
  {
    id: 'CRSI.DOB.3',
    questionText: 'preQualifyingQuestionnaire.CRSI.DOB.3.questionText',
    name: 'townCityOfBirth',
    style: Style.Embedded,
    group: 'Date and Place of Birth',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Town or City of Birth', required: false }
      ]
    },
  },
  {
    id: 'CRSI.Signer.1',
    name: 'signerName',
    info: helpText.signerName,
    questionText: 'preQualifyingQuestionnaire.CRSI.Signer.1.questionText',
    style: Style.Card,
    group: 'Signer Details',
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Signer Name', required: true }
      ]
    },
    errorMessage: 'Required: Signer name is required.'
  },
  {
    id: 'CRSI.Signer.2',
    name: 'capacityField',
    info: helpText.capacity,
    questionText: 'preQualifyingQuestionnaire.CRSI.Signer.2.questionText',
    style: Style.Embedded,
    group: 'Signer Details',
    complexCapacityContraint: {
      signerNameId: 'CRSI.Signer.1',
      givenNameId: ['CRSI.NAME.1', 'CRSI.NAME.2', 'CRSI.NAME.3'],
      expectedValue: 'Signing on Own Behalf'
    },
    inputs: {
      type: InputType.Dropdown,
      defaultValue: { value: 'Signing on Own Behalf', label: 'Signing on Own Behalf' },
      items: [
        { value: 'Signing on Own Behalf', label: 'Signing on Own Behalf' },
        { value: 'Conservator', label: 'Conservator' },
        { value: 'Custodian for Minor Child', label: 'Custodian for Minor Child' },
        { value: 'Father', label: 'Father' },
        { value: 'Guardian', label: 'Guardian' },
        { value: 'Mother', label: 'Mother' },
        { value: 'Power of Attorney', label: 'Power of Attorney' },
        { value: 'Attorney in Fact', label: 'Attorney in Fact' },
        { value: 'Authorized Signer', label: 'Authorized Signer' },
        { value: 'Other', label: 'Other' },
      ]
    },
    errorMessage: 'Capacity is required when name and signer name do not match.'
  },
  {
    id: 'CRSI.Signer.3',
    name: 'capacityFieldOther',
    questionText: 'preQualifyingQuestionnaire.CRSI.Signer.3.questionText',
    style: Style.Embedded,
    group: 'Signer Details',
    dynamicUpdate: {
      inputQuestionId: 'CRSI.Signer.2',
      condition: DynamicUpdateCondition.IsNot,
      expectedValue: 'Other',
      action: DynamicUpdateAction.HideAndClear,
      conditionMet: true
    },
    inputs: {
      type: InputType.TextFields,
      fields: [
        { placeholder: 'Capacity', required: true }
      ]
    },
    errorMessage: 'Please provide the capacity in which you are acting.'
  },
];

export default crsiQuestions;
